import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3.js";

let API = {
  getRecurringGifts: ({ fundID }) => {
    let fetch = new FnrFetch3("/give/getUserRecurringGiftsForFund", {
      fundID: fundID,
    });
    return fetch.post();
  },
};

export default API;
